module.exports = require("timers");


//////////////////
// WEBPACK FOOTER
// external "timers"
// module id = 257
// module chunks = 0 1